import { render } from "./PaperBookPanel.vue?vue&type=template&id=325c893e&scoped=true"
import script from "./PaperBookPanel.vue?vue&type=script&lang=js"
export * from "./PaperBookPanel.vue?vue&type=script&lang=js"

import "./PaperBookPanel.vue?vue&type=style&index=0&id=325c893e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325c893e"]])

export default __exports__